// import React, { useState, useEffect } from 'react';
// import { ArrowLeft, Eye, ArrowRight, Plane, Heart, MapPin, Calendar, Camera, Star, Globe, ChevronLeft, ChevronRight } from 'lucide-react';
// import { Link } from 'react-router-dom';

// const ImageAdContent = ({ isInPreview = false, isExpanded = false, onExpand, onClose }) => {
//   const [currentImageIndex, setCurrentImageIndex] = useState(0);
//   const [showControls, setShowControls] = useState(false);

  // const images = [
  //   { 
  //     src: '/assets/1.png', 
  //     alt: 'Filter Classic Ad',
  //   },
  //   { 
  //     src: '/assets/2.png',       
  //     alt: 'Filter Zero Ad',
  //   },
  //   { 
  //     src: '/assets/3.png',       
  //     alt: 'Filter Life Ad',
  //   },
  //   { 
  //     src: '/assets/4.png',       
  //     alt: 'Filter Orange Ad',
  //   }
  // ];

//   const nextImage = (e) => {
//     e?.stopPropagation();
//     setCurrentImageIndex((prev) => (prev + 1) % images.length);
//   };

//   const prevImage = (e) => {
//     e?.stopPropagation();
//     setCurrentImageIndex((prev) => (prev - 1 + images.length) % images.length);
//   };

//   const handleExpand = () => {
//     if (onExpand && !isInPreview) {
//       onExpand();
//     }
//   };

//   const handleImageClick = () => {
//     if (!isExpanded) {
//       handleExpand();
//     } else {
//       nextImage();
//     }
//   };

//   return (
//     <div className={`w-full h-full relative overflow-hidden ${isExpanded ? 'fixed inset-0 z-50 bg-black' : ''}`}>
//       {!isExpanded ? (
//         <div className="relative h-full">
//           {/* Compact Image Ad */}
//           <div 
//             className={`relative cursor-pointer transform transition-all duration-300 ${
//               !isInPreview ? 'hover:scale-105' : ''
//             } w-full h-full`}
//             onClick={handleImageClick}
//             onMouseEnter={() => setShowControls(true)}
//             onMouseLeave={() => setShowControls(false)}
//           >
//             {/* Image Container */}
//             <div className="relative w-full h-full overflow-hidden">
//               <img
//                 src={images[currentImageIndex].src}
//                 alt={images[currentImageIndex].alt}
//                 className="w-full h-full object-cover transition-opacity duration-300"
//               />

//               {/* Navigation Controls */}
//               {showControls && images.length > 1 && (
//                 <>
//                   <button
//                     onClick={prevImage}
//                     className="absolute left-2 top-1/2 transform -translate-y-1/2 w-8 h-8 bg-black bg-opacity-60 hover:bg-opacity-80 rounded-full flex items-center justify-center text-white transition-all duration-200"
//                   >
//                     <ChevronLeft size={16} />
//                   </button>
//                   <button
//                     onClick={nextImage}
//                     className="absolute right-2 top-1/2 transform -translate-y-1/2 w-8 h-8 bg-black bg-opacity-60 hover:bg-opacity-80 rounded-full flex items-center justify-center text-white transition-all duration-200"
//                   >
//                     <ChevronRight size={16} />
//                   </button>
//                 </>
//               )}

//               {/* Image indicators */}
//               {/* {images.length > 1 && (
//                 <div className="absolute bottom-2 left-1/2 transform -translate-x-1/2 flex space-x-1">
//                   {images.map((_, index) => (
//                     <div
//                       key={index}
//                       className={`w-2 h-2 rounded-full transition-all duration-200 ${
//                         index === currentImageIndex ? 'bg-white' : 'bg-white/50'
//                       }`}
//                     />
//                   ))}
//                 </div>
//               )} */}

//               {/* Ad Label */}
//               <div className="absolute top-2 left-2 bg-black bg-opacity-60 text-white px-2 py-1 rounded text-xs font-medium">
//                 AD
//               </div>
//             </div>
//           </div>
//         </div>
//       ) : (
//         /* Expanded Image Experience - Full Screen */
//         <div className="w-full h-full flex items-center justify-center relative">
//           <button
//             onClick={onClose}
//             className="absolute top-4 right-4 w-10 h-10 bg-white/20 hover:bg-white/30 rounded-full flex items-center justify-center text-white text-xl font-bold transition-all duration-300 hover:scale-110 z-10"
//           >
//             ×
//           </button>
          
//           <div className="relative w-full h-full max-w-4xl flex items-center justify-center">
//             {/* Navigation arrows for expanded view */}
//             {images.length > 1 && (
//               <>
//                 <button
//                   onClick={prevImage}
//                   className="absolute left-4 top-1/2 transform -translate-y-1/2 w-12 h-12 bg-white/20 hover:bg-white/30 rounded-full flex items-center justify-center text-white transition-all duration-300 hover:scale-110 z-10"
//                 >
//                   <ChevronLeft size={24} />
//                 </button>
//                 <button
//                   onClick={nextImage}
//                   className="absolute right-4 top-1/2 transform -translate-y-1/2 w-12 h-12 bg-white/20 hover:bg-white/30 rounded-full flex items-center justify-center text-white transition-all duration-300 hover:scale-110 z-10"
//                 >
//                   <ChevronRight size={24} />
//                 </button>
//               </>
//             )}

//             <img
//               src={images[currentImageIndex].src}
//               alt={images[currentImageIndex].alt}
//               className="max-w-full max-h-full object-contain cursor-pointer"
//               onClick={nextImage}
//             />

//             {/* Image indicators for expanded view */}
//             {/* {images.length > 1 && (
//               <div className="absolute bottom-4 left-1/2 transform -translate-x-1/2 flex space-x-2">
//                 {images.map((_, index) => (
//                   <button
//                     key={index}
//                     onClick={() => setCurrentImageIndex(index)}
//                     className={`w-3 h-3 rounded-full transition-all duration-200 ${
//                       index === currentImageIndex ? 'bg-white' : 'bg-white/50'
//                     }`}
//                   />
//                 ))}
//               </div>
//             )} */}

//             {/* Image counter */}
//             <div className="absolute top-4 left-4 bg-black/60 backdrop-blur-sm rounded-lg px-3 py-2 text-white text-sm">
//               {currentImageIndex + 1} / {images.length}
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// function App() {
//   const [isMobile, setIsMobile] = useState(true);
//   const [isExpanded, setIsExpanded] = useState(false);

//   return (
//     <>
//     <div className="min-h-screen bg-gray-50 mt-10">
//       <div className="container mx-auto px-4 py-8 lg:py-12">
//         <div className="flex flex-col lg:flex-row lg:items-start lg:space-x-12">
//           {/* Left column - Content */}
//           <div className="flex-1 lg:max-w-lg">
//             {/* Header */}
//             <header className="animate-slide-up">
//               {/* Title and tag */}
//               <div className="mb-4 lg:mt-16 md:mt-10 sm:mt-0">
//                 <div className="flex flex-wrap items-center gap-3 mb-3">
//                   <h1 className="text-3xl lg:text-4xl font-bold text-gray-900 leading-tight">
//                   Click the Filter. See the Magic.
//                   </h1>
//                   <span className="bg-blue-500 text-white px-3 py-1 rounded-full text-sm font-medium">
//                   Gamification
//                   </span>
//                 </div>
//               </div>
//             </header>

//             {/* Content Section */}
//             <div className="animate-slide-up" style={{ animationDelay: '0.2s' }}>
//               {/* Make it yours section */}
//               <div className="mb-8">
//                 <h2 className="text-lg font-bold text-blue-600 mb-4 tracking-wide">
//                 SHOWCASE YOUR FEATURES LIVE
//                 </h2>
//                 <p className="text-gray-700 leading-relaxed mb-6 max-w-md">
//                 This interactive image carousel lets users tap through filters to see real-time changes inside the phone frame, perfect for highlighting camera capabilities. Each click swaps the visual, showing off how your tech transforms every shot. Samsung launch a hands-on demo that feels like using the device itself.

//                 </p>
                
//                 {/* CTA Button */}
//                 <Link to='/contact'>
//                 <button className="group bg-white border-2 border-blue-500 text-blue-500 px-6 py-3 rounded-full font-medium hover:bg-blue-500 hover:text-white transition-all duration-300 flex items-center space-x-2 shadow-sm hover:shadow-md transform hover:-translate-y-0.5">
//                   <span>Start with this Template</span>
//                   <ArrowRight className="w-4 h-4 transform group-hover:translate-x-1 transition-transform duration-200" />
//                 </button>
//                 </Link>
//               </div>
//             </div>
//           </div>

//           {/* Right column - Template Preview */}
//           <div className="flex-1 lg:max-w-2xl mt-8 lg:mt-0">
//             {/* Preview toggle */}
//             <div className="hidden lg:flex justify-center mt-2 animate-fade-in mb-4" style={{ animationDelay: '0.3s' }}>
//               <div className="bg-white rounded-full px-6 py-3 shadow-lg border border-gray-200">
//                 <div className="flex items-center space-x-4">
//                   <div className="flex items-center space-x-3">
//                     <span className={`text-sm font-medium transition-colors ${isMobile ? 'text-blue-600' : 'text-gray-600'}`}>
//                       Mobile
//                     </span>
//                     <button
//                       onClick={() => setIsMobile(!isMobile)}
//                       className="relative w-12 h-6 bg-blue-500 rounded-full transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
//                     >
//                       <div className={`absolute top-1 w-4 h-4 bg-white rounded-full transition-transform duration-200 ${isMobile ? 'left-1' : 'left-7'}`}></div>
//                     </button>
//                     <span className={`text-sm font-medium transition-colors ${!isMobile ? 'text-blue-600' : 'text-gray-600'}`}>
//                       Desktop
//                     </span>
//                   </div>
//                 </div>
//               </div>
//             </div>

//             <div className="relative animate-fade-in" style={{ animationDelay: '0.4s' }}>
//               {/* Mobile Mockup */}
//               {isMobile && (
//                 <div className="mx-auto max-w-xs">
//                   {/* iPhone mockup */}
//                   <div className="relative rounded-[2.5rem] p-2 shadow-2xl">
//                     {/* Status bar area */}
//                     <div className="bg-white rounded-[2rem] overflow-hidden">
//                       {/* Status bar */}
//                       <div className="bg-white px-6 py-2 flex justify-between items-center text-black text-sm font-medium">
//                         <span>9:41</span>
//                         <div className="flex items-center space-x-1">
//                           <div className="flex space-x-1">
//                             <div className="w-1 h-1 bg-black rounded-full"></div>
//                             <div className="w-1 h-1 bg-black rounded-full"></div>
//                             <div className="w-1 h-1 bg-black rounded-full"></div>
//                             <div className="w-1 h-1 bg-black rounded-full"></div>
//                           </div>
//                           <div className="w-6 h-3 border border-black rounded-sm relative">
//                             <div className="w-4/5 h-full bg-green-500 rounded-sm"></div>
//                           </div>
//                         </div>
//                       </div>

//                       {/* Browser bar */}
//                       <div className="bg-gray-100 px-4 py-3 flex items-center space-x-3">
//                         <div className="flex-1 bg-white rounded-lg px-3 py-2 text-sm text-gray-600 flex items-center justify-center">
//                           publisher.com
//                         </div>
//                       </div>

//                       {/* Content area */}
//                       <div className="p-4 bg-gray-50  h-[400px] overflow-y-auto hide-scrollbar">
//                         <div className="space-y-3">
//                           <div className="h-3 bg-gray-200 rounded w-full"></div>
//                           <div className="h-3 bg-gray-200 rounded w-full"></div>
//                           <div className="h-3 bg-gray-200 rounded w-full"></div>
//                         </div>
                        
//                         {/* Image Ad - Full width on mobile with same gap from top */}
//                         <div className="mb-6">
//                           <div className="h-64 rounded-lg overflow-hidden">
//                             <ImageAdContent 
//                               isInPreview={true}
//                               isExpanded={isExpanded}
//                               onExpand={() => setIsExpanded(true)}
//                               onClose={() => setIsExpanded(false)}
//                             />
//                           </div>
//                         </div>
//                         <div className="space-y-3">
//                           <div className="h-3 bg-gray-200 rounded w-full"></div>
//                           <div className="h-3 bg-gray-200 rounded w-5/6"></div>
//                           <div className="h-3 bg-gray-200 rounded w-4/6"></div>
//                         </div>
//                         <div className="space-y-3 mt-2">
//                           <div className="h-3 bg-gray-200 rounded w-full"></div>
//                           <div className="h-3 bg-gray-200 rounded w-5/6"></div>
//                           <div className="h-3 bg-gray-200 rounded w-4/6"></div>
//                         </div>
//                         <div className="space-y-3 mt-2">
//                           <div className="h-3 bg-gray-200 rounded w-full"></div>
//                           <div className="h-3 bg-gray-200 rounded w-5/6"></div>
//                           <div className="h-3 bg-gray-200 rounded w-4/6"></div>
//                         </div>
//                         <div className="space-y-3 mt-2">
//                           <div className="h-3 bg-gray-200 rounded w-full"></div>
//                           <div className="h-3 bg-gray-200 rounded w-5/6"></div>
//                           <div className="h-3 bg-gray-200 rounded w-4/6"></div>
//                         </div>
//                         {/* Additional content placeholders */}
//                         <div className="space-y-3">
//                           <div className="h-3 bg-gray-200 rounded w-full"></div>
//                           <div className="h-3 bg-gray-200 rounded w-full"></div>
//                           <div className="h-3 bg-gray-200 rounded w-full"></div>
//                         </div>
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               )}

//               {/* Desktop Mockup */}
//               {!isMobile && (
//                 <div className="w-full max-w-2xl mx-auto">
//                   {/* Desktop Screen Frame */}
//                   <div className="bg-gray-200 rounded-xl p-3 shadow-2xl">
//                     {/* Screen */}
//                     <div className="bg-white rounded-lg overflow-hidden shadow-inner" style={{ aspectRatio: '16/10' }}>
//                       {/* macOS-style window header */}
//                       <div className="bg-gray-100 px-1 py-1 flex items-center border-b border-gray-200">
//                         <div className="flex space-x-2">
//                           <div className="w-3 h-3 bg-red-400 rounded-full"></div>
//                           <div className="w-3 h-3 bg-yellow-400 rounded-full"></div>
//                           <div className="w-3 h-3 bg-green-400 rounded-full"></div>
//                         </div>
//                         <div className="flex-1 mx-6">
//                           <div className="bg-white rounded-md px-1 py-1 text-sm text-gray-600 border shadow-sm max-w-md">
//                             🔒 publisher.com
//                           </div>
//                         </div>
//                         <div className="flex space-x-1">
//                           <div className="w-4 h-4 bg-gray-300 rounded"></div>
//                           <div className="w-4 h-4 bg-gray-300 rounded"></div>
//                         </div>
//                       </div>

//                       {/* Browser content area */}
//                       <div className="p-1 bg-gray-50 h-[500px] overflow-y-auto hide-scrollbar">
//                         {/* Page header */}
//                         <div className="mb-2">
//                           <div className="h-4 bg-gray-200 rounded w-1/3 mb-2"></div>
//                           <div className="h-3 bg-gray-200 rounded w-1/2"></div>
//                         </div>

//                         {/* Image Ad positioned in content with same gap from top */}
//                         <div className="flex justify-center mb-2">
//                           <div className="w-80 h-80 overflow-hidden">
//                             <ImageAdContent 
//                               isInPreview={true}
//                               isExpanded={isExpanded}
//                               onExpand={() => setIsExpanded(true)}
//                               onClose={() => setIsExpanded(false)}
//                             />
//                           </div>
//                         </div>

//                         {/* Additional content placeholders */}
//                         <div className="grid grid-cols-2 gap-6 mb-6">
//                           <div className="space-y-3">
//                             <div className="h-4 bg-gray-200 rounded w-full"></div>
//                             <div className="h-3 bg-gray-200 rounded w-5/6"></div>
//                             <div className="h-3 bg-gray-200 rounded w-4/6"></div>
//                           </div>
//                           <div className="space-y-3">
//                             <div className="h-4 bg-gray-200 rounded w-full"></div>
//                             <div className="h-3 bg-gray-200 rounded w-5/6"></div>
//                             <div className="h-3 bg-gray-200 rounded w-4/6"></div>
//                           </div>
//                         </div>
//                         <div className="grid grid-cols-3 gap-4">
//                             <div className="h-24 bg-gray-200 rounded"></div>
//                             <div className="h-24 bg-gray-200 rounded"></div>
//                             <div className="h-24 bg-gray-200 rounded"></div>
//                           </div>
//                           <div className="grid grid-cols-2 gap-6 mb-6">
//                           <div className="space-y-3">
//                             <div className="h-4 bg-gray-200 rounded w-full"></div>
//                             <div className="h-3 bg-gray-200 rounded w-5/6"></div>
//                             <div className="h-3 bg-gray-200 rounded w-4/6"></div>
//                           </div>
//                           <div className="space-y-3">
//                             <div className="h-4 bg-gray-200 rounded w-full"></div>
//                             <div className="h-3 bg-gray-200 rounded w-5/6"></div>
//                             <div className="h-3 bg-gray-200 rounded w-4/6"></div>
//                           </div>
//                         </div>
//                         {/* Sidebar placeholders */}
//                         <div className="grid grid-cols-3 gap-4">
//                           <div className="h-24 bg-gray-200 rounded"></div>
//                           <div className="h-24 bg-gray-200 rounded"></div>
//                           <div className="h-24 bg-gray-200 rounded"></div>
//                         </div>
//                       </div>
//                     </div>
//                   </div>
                  
//                   {/* Monitor stand */}
//                   <div className="flex justify-center">
//                     <div className="w-20 h-4 bg-gray-200 rounded-b-lg"></div>
//                   </div>
//                   <div className="flex justify-center">
//                     <div className="w-32 h-2 bg-gray-300 rounded-full"></div>
//                   </div>
//                 </div>
//               )}
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* Expanded Image Overlay */}
//       {isExpanded && (
//         <div className="fixed inset-0 z-50">
//           <ImageAdContent 
//             isExpanded={true}
//             onClose={() => setIsExpanded(false)}
//           />
//         </div>
//       )}

//       <style jsx>{`
//         @keyframes slide-up {
//           from {
//             opacity: 0;
//             transform: translateY(20px);
//           }
//           to {
//             opacity: 1;
//             transform: translateY(0);
//           }
//         }
        
//         @keyframes fade-in {
//           from { opacity: 0; }
//           to { opacity: 1; }
//         }
        
//         .animate-slide-up {
//           animation: slide-up 0.6s ease-out forwards;
//         }
        
//         .animate-fade-in {
//           animation: fade-in 0.6s ease-out forwards;
//         }
//       `}</style>
//     </div>
    //   <div className="max-w-7xl mx-auto px-4 py-10">
    //                         <h1 className="text-3xl font-bold text-center text-gray-800 mb-10">Discover More Ads</h1>
                      
    //                         <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
    //                           {/* Card 1 */}
    //                           <Link to="/ps" className="block group rounded-xl overflow-hidden shadow-lg transition-transform duration-300 transform hover:scale-105 hover:shadow-2xl">
    //                             <img
    //                               src="/assets/ps.avif"
    //                               alt="Card 1"
    //                               className="w-full h-60 object-cover transition-opacity duration-300 group-hover:opacity-80"
    //                             />
    //                             <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent text-white p-4 opacity-0 group-hover:opacity-100 transition-all duration-300">
    //                               <h2 className="text-lg font-semibold">PS5</h2>
    //                             </div>
    //                           </Link>
                      
    //                           {/* Card 2 */}
    //                           <Link to="/mollers" className="block group rounded-xl overflow-hidden shadow-lg transition-transform duration-300 transform hover:scale-105 hover:shadow-2xl">
    //                             <img
    //                               src="/assets/moll.avif"
    //                               alt="Card 2"
    //                               className="w-full h-60 object-cover transition-opacity duration-300 group-hover:opacity-80"
    //                             />
    //                             <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent text-white p-4 opacity-0 group-hover:opacity-100 transition-all duration-300">
    //                               <h2 className="text-lg font-semibold">Mollers</h2>
    //                             </div>
    //                           </Link>
                      
    //                           {/* Card 3 */}
    //                           <Link to="/tiger" className="block group rounded-xl overflow-hidden shadow-lg transition-transform duration-300 transform hover:scale-105 hover:shadow-2xl">
    //                             <img
    //                               src="/assets/tiger.avif"
    //                               alt="Card 3"
    //                               className="w-full h-60 object-cover transition-opacity duration-300 group-hover:opacity-80"
    //                             />
    //                             <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent text-white p-4 opacity-0 group-hover:opacity-100 transition-all duration-300">
    //                               <h2 className="text-lg font-semibold">Tiger</h2>
    //                             </div>
    //                           </Link>
                      
    //                           {/* Card 4 */}
    //                           <Link to="/abcbeer" className="block group rounded-xl overflow-hidden shadow-lg transition-transform duration-300 transform hover:scale-105 hover:shadow-2xl">
    //                             <img
    //                               src="/assets/ab.avif"
    //                               alt="Card 4"
    //                               className="w-full h-60 object-cover transition-opacity duration-300 group-hover:opacity-80"
    //                             />
    //                             <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent text-white p-4 opacity-0 group-hover:opacity-100 transition-all duration-300">
    //                               <h2 className="text-lg font-semibold">ABC Beer</h2>
    //                             </div>
    //                           </Link>
                      
                             
    //                         </div>
    //                       </div>
    // </>


//   );
// }

// export default App;


// import React, { useState } from 'react';
// import { ChevronLeft, ChevronRight, Copy, RotateCcw, ZoomIn, Eye, MousePointer2, Hand, Search, Plus, Move, Filter } from 'lucide-react';

// export default function Cokedetail() {
//   const [selectedDevice, setSelectedDevice] = useState('Mobile');
//   const [currentImageIndex, setCurrentImageIndex] = useState(0);
//   const [isAnimating, setIsAnimating] = useState(false);
//   const [cursorStyle, setCursorStyle] = useState('default');
//   const [clickAnimation, setClickAnimation] = useState({ show: false, x: 0, y: 0 });
//   const [ripples, setRipples] = useState([]);
//   const [selectedFilter, setSelectedFilter] = useState('original');

//   // Sample image data with placeholder content
//   const images = [
//     { 
//       src: '/assets/1.png', 
//       alt: 'Filter Classic Ad',
//     },
//     { 
//       src: '/assets/2.png',       
//       alt: 'Filter Zero Ad',
//     },
//     { 
//       src: '/assets/3.png',       
//       alt: 'Filter Life Ad',
//     },
//     { 
//       src: '/assets/4.png',       
//       alt: 'Filter Orange Ad',
//     }
//   ];

//   // Image filters configuration
//   const imageFilters = [
//     {
//       id: 'original',
//       name: 'Original',
//       filter: 'none',
//       preview: '🎨',
//       description: 'No filter applied'
//     },
//     {
//       id: 'vintage',
//       name: 'Vintage',
//       filter: 'sepia(0.8) contrast(1.2) brightness(0.9)',
//       preview: '📸',
//       description: 'Classic vintage look'
//     },
//     {
//       id: 'cool',
//       name: 'Cool',
//       filter: 'hue-rotate(180deg) saturate(1.3) brightness(1.1)',
//       preview: '❄️',
//       description: 'Cool blue tones'
//     },
//     {
//       id: 'warm',
//       name: 'Warm',
//       filter: 'hue-rotate(30deg) saturate(1.4) brightness(1.05) contrast(1.1)',
//       preview: '🔥',
//       description: 'Warm orange tones'
//     },
//     {
//       id: 'dramatic',
//       name: 'Dramatic',
//       filter: 'contrast(1.5) brightness(0.8) saturate(1.6)',
//       preview: '⚡',
//       description: 'High contrast drama'
//     },
//     {
//       id: 'grayscale',
//       name: 'B&W',
//       filter: 'grayscale(1) contrast(1.2)',
//       preview: '⚫',
//       description: 'Black and white'
//     }
//   ];

//   const nextImage = () => {
//     if (isAnimating) return;
//     setIsAnimating(true);
//     setTimeout(() => {
//       setCurrentImageIndex((prev) => (prev + 1) % images.length);
//       setIsAnimating(false);
//     }, 200);
//   };

//   const prevImage = () => {
//     if (isAnimating) return;
//     setIsAnimating(true);
//     setTimeout(() => {
//       setCurrentImageIndex((prev) => (prev - 1 + images.length) % images.length);
//       setIsAnimating(false);
//     }, 200);
//   };

//   const goToImage = (index) => {
//     if (isAnimating || index === currentImageIndex) return;
//     setIsAnimating(true);
//     setTimeout(() => {
//       setCurrentImageIndex(index);
//       setIsAnimating(false);
//     }, 200);
//   };

//   const createRipple = (x, y) => {
//     const rippleId = Date.now() + Math.random();
//     const newRipple = { id: rippleId, x, y };
//     setRipples(prev => [...prev, newRipple]);
    
//     // Remove ripple after animation
//     setTimeout(() => {
//       setRipples(prev => prev.filter(ripple => ripple.id !== rippleId));
//     }, 1000);
//   };

//   const handleImageClick = (e) => {
//     if (isAnimating) return;
    
//     const rect = e.currentTarget.getBoundingClientRect();
//     const clickX = e.clientX - rect.left;
//     const clickY = e.clientY - rect.top;
//     const imageWidth = rect.width;
    
//     // Create ripple effect
//     createRipple(clickX, clickY);
    
//     // Show enhanced click animation
//     setClickAnimation({ show: true, x: clickX, y: clickY });
//     setTimeout(() => setClickAnimation({ show: false, x: 0, y: 0 }), 800);
    
//     // Divide image into 3 zones: left (30%), center (40%), right (30%)
//     if (clickX < imageWidth * 0.3) {
//       // Left zone - go to previous image
//       prevImage();
//     } else if (clickX > imageWidth * 0.7) {
//       // Right zone - go to next image
//       nextImage();
//     } else {
//       // Center zone - go to next image
//       nextImage();
//     }
//   };

//   const handleFilterClick = (filterId) => {
//     setSelectedFilter(filterId);
//     // Add a small animation effect when filter changes
//     setIsAnimating(true);
//     setTimeout(() => {
//       setIsAnimating(false);
//     }, 300);
//   };

//   const getCurrentFilter = () => {
//     const filter = imageFilters.find(f => f.id === selectedFilter);
//     return filter ? filter.filter : 'none';
//   };

//   const cursorOptions = [
//     { type: 'default', icon: MousePointer2, label: 'Default' },
//     { type: 'pointer', icon: Hand, label: 'Pointer' },
//     { type: 'grab', icon: Move, label: 'Grab' },
//     { type: 'zoom-in', icon: Search, label: 'Zoom' },
//     { type: 'crosshair', icon: Plus, label: 'Crosshair' }
//   ];

//   return (
//     <div className="flex flex-col md:flex-row min-h-screen bg-gray-50 mt-14 overflow-x-hidden">
//       {/* Left Sidebar */}
//       <div className="w-full md:w-64 bg-white border-b md:border-b-0 md:border-r border-gray-200 p-4">
//         <div className="mb-6">
//           <h1 className="text-xl font-semibold text-gray-800 mb-1">Filter</h1>
//           <p className="text-sm text-blue-500 mb-2">ID: 235756</p>
//           <button className="text-sm text-blue-500 hover:underline">
//             Switch to previous version
//           </button>
//         </div>

//         <div className="bg-blue-500 text-white p-3 rounded-lg mb-4">
//           <h3 className="font-medium mb-2 truncate">Filter_upsize...</h3>
//           <div className="text-xs space-y-1">
//             <p>Ad dimension: 300x600</p>
//             <p>Ad type: Banner - Javascript tag</p>
//           </div>
//         </div>

//         {/* Image Filters */}
//         <div className="mb-6">
//           <h4 className="text-sm font-medium text-gray-600 mb-3 flex items-center gap-2">
//             <Filter className="h-4 w-4" />
//             Image Filters
//           </h4>
//           <div className="grid grid-cols-2 gap-2">
//             {imageFilters.map((filter) => (
//               <button
//                 key={filter.id}
//                 className={`p-3 rounded-lg text-xs transition-all duration-200 hover:scale-105 ${
//                   selectedFilter === filter.id
//                     ? 'bg-blue-100 text-blue-700 border-2 border-blue-300 shadow-sm'
//                     : 'bg-gray-50 text-gray-700 border border-gray-200 hover:bg-gray-100'
//                 }`}
//                 onClick={() => handleFilterClick(filter.id)}
//                 title={filter.description}
//               >
//                 <div className="text-lg mb-1">{filter.preview}</div>
//                 <div className="font-medium">{filter.name}</div>
//               </button>
//             ))}
//           </div>
//         </div>

//         {/* Cursor Style Selector */}
//         <div className="mb-4">
//           <h4 className="text-sm font-medium text-gray-600 mb-2">Cursor Style</h4>
//           <div className="space-y-1">
//             {cursorOptions.map((option) => {
//               const IconComponent = option.icon;
//               return (
//                 <button
//                   key={option.type}
//                   className={`w-full text-left px-3 py-2 rounded-lg text-sm transition-all duration-200 flex items-center gap-2 ${
//                     cursorStyle === option.type
//                       ? 'bg-blue-100 text-blue-700 shadow-sm'
//                       : 'hover:bg-gray-100 text-gray-700'
//                   }`}
//                   onClick={() => setCursorStyle(option.type)}
//                 >
//                   <IconComponent className="h-4 w-4" />
//                   {option.label}
//                 </button>
//               );
//             })}
//           </div>
//         </div>
//       </div>

//       {/* Center Content */}
//       <div className="flex-1 flex flex-col">
//         {/* Header */}
//         <div className="bg-white border-b border-gray-200 p-4">
//           <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-2">
//             <h2 className="text-lg font-medium text-gray-800 flex items-center gap-2">
//             Filter
//               <Copy className="h-4 w-4 text-gray-400 cursor-pointer hover:text-gray-600" />
//             </h2>
//             <div className="flex items-center gap-2">
//               <span
//                 className={`px-3 py-1 rounded-full text-xs cursor-pointer transition-all duration-200 ${
//                   selectedDevice === 'Mobile'
//                     ? 'bg-purple-100 text-purple-700 shadow-sm'
//                     : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
//                 }`}
//                 onClick={() => setSelectedDevice('Mobile')}
//               >
//                 Mobile
//               </span>
//               <span
//                 className={`px-3 py-1 rounded-full text-xs cursor-pointer transition-all duration-200 ${
//                   selectedDevice === 'Desktop'
//                     ? 'bg-purple-100 text-purple-700 shadow-sm'
//                     : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
//                 }`}
//                 onClick={() => setSelectedDevice('Desktop')}
//               >
//                 Desktop
//               </span>
//             </div>
//           </div>
//         </div>

//         {/* Filter Preview Bar */}
//         <div className="bg-white border-b border-gray-200 p-3">
//           <div className="flex items-center justify-center gap-4 overflow-x-auto">
//             <span className="text-sm text-gray-500 whitespace-nowrap">Try a new look! Click the filters below:</span>
//             <div className="flex gap-2">
//               {imageFilters.slice(0, 4).map((filter) => (
//                 <button
//                   key={filter.id}
//                   className={`flex items-center gap-1 px-3 py-1 rounded-full text-xs transition-all duration-200 hover:scale-105 ${
//                     selectedFilter === filter.id
//                       ? 'bg-blue-500 text-white shadow-md'
//                       : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
//                   }`}
//                   onClick={() => handleFilterClick(filter.id)}
//                 >
//                   <span>{filter.preview}</span>
//                   <span className="hidden sm:inline">{filter.name}</span>
//                 </button>
//               ))}
//             </div>
//           </div>
//         </div>

//         {/* Navigation */}
//         <div className="bg-white border-b border-gray-200 p-4 flex items-center justify-between">
//           <button 
//             className="flex items-center gap-2 text-gray-400 hover:text-gray-600 transition-all duration-200 disabled:opacity-50 hover:scale-105"
//             onClick={prevImage}
//             disabled={isAnimating}
//           >
//             <ChevronLeft className="h-4 w-4" />
//             Prev Ad
//           </button>
          
//           <div className="flex items-center gap-2">
//             <span className="text-sm text-gray-500">
//               {currentImageIndex + 1} of {images.length}
//             </span>
//             <div className="flex gap-1 ml-2">
//               {images.map((_, index) => (
//                 <button
//                   key={index}
//                   className={`w-2 h-2 rounded-full transition-all duration-200 ${
//                     currentImageIndex === index 
//                       ? 'bg-blue-500 w-4' 
//                       : 'bg-gray-300 hover:bg-gray-400'
//                   }`}
//                   onClick={() => goToImage(index)}
//                 />
//               ))}
//             </div>
//           </div>
          
//           <button 
//             className="flex items-center gap-2 text-gray-400 hover:text-gray-600 transition-all duration-200 disabled:opacity-50 hover:scale-105"
//             onClick={nextImage}
//             disabled={isAnimating}
//           >
//             Next Ad
//             <ChevronRight className="h-4 w-4" />
//           </button>
//         </div>

//         {/* Ad Preview Area */}
//         <div className="flex-1 flex items-center justify-center p-4 md:p-8 bg-gray-100 relative overflow-auto">
//           {/* Navigation arrows */}
//           <button 
//             className="absolute left-4 md:left-8 top-1/2 transform -translate-y-1/2 flex items-center gap-1 text-gray-500 hover:text-gray-700 bg-white hover:bg-gray-50 px-3 py-2 rounded-lg shadow-lg text-sm transition-all duration-200 hover:scale-105 disabled:opacity-50 z-10"
//             onClick={prevImage}
//             disabled={isAnimating}
//           >
//             <ChevronLeft className="h-4 w-4" />
//             Prev
//           </button>
//           <button 
//             className="absolute right-4 md:right-8 top-1/2 transform -translate-y-1/2 flex items-center gap-1 text-gray-500 hover:text-gray-700 bg-white hover:bg-gray-50 px-3 py-2 rounded-lg shadow-lg text-sm transition-all duration-200 hover:scale-105 disabled:opacity-50 z-10"
//             onClick={nextImage}
//             disabled={isAnimating}
//           >
//             Next
//             <ChevronRight className="h-4 w-4" />
//           </button>

//           {/* Mobile Device Frame */}
//           {selectedDevice === 'Mobile' ? (
//             <div className="relative max-w-xs mx-auto">
//               {/* Selection background with dashed border */}
//               <div className="absolute -inset-3 border-2 border-dashed border-blue-400 bg-blue-50 bg-opacity-30 rounded-3xl transition-all duration-300"></div>

//               {/* Mobile device frame */}
//               <div className="bg-gray-800 rounded-3xl p-3 shadow-2xl">
//                 <div className="bg-black rounded-2xl p-1 shadow-inner">
//                   {/* Mobile screen with ad content */}
//                   <div 
//                     className="w-[280px] h-[500px] bg-gray-900 rounded-xl overflow-hidden relative group cursor-pointer"
//                     style={{ cursor: cursorStyle }}
//                     onClick={handleImageClick}
//                   >
//                     <div className={`transition-all duration-300 w-full h-full ${isAnimating ? 'opacity-0 scale-90 rotate-1' : 'opacity-100 scale-100 rotate-0'}`}>
//                       <div className="w-full h-full flex items-center justify-center text-white relative overflow-hidden group-hover:scale-[1.02] transition-transform duration-300">
//                         <img 
//                           src={images[currentImageIndex].src} 
//                           alt={images[currentImageIndex].alt}
//                           className="w-full h-full object-contain absolute inset-0 transition-all duration-300"
//                           style={{ 
//                             objectFit: 'contain',
//                             filter: getCurrentFilter()
//                           }}
//                         />
//                         {/* Navigation indicator at bottom */}
//                         <div className="absolute bottom-4 left-1/2 transform -translate-x-1/2 z-10 pointer-events-none">
//                           <div className="bg-black bg-opacity-60 px-3 py-2 rounded-full backdrop-blur-sm flex items-center gap-2">
//                             <div className="text-lg opacity-80 animate-pulse">👆</div>
//                             <div className="text-xs text-gray-200">Tap to navigate</div>
//                           </div>
//                         </div>
//                       </div>
//                     </div>
                    
//                     {/* Enhanced click animation with multiple effects */}
//                     {clickAnimation.show && (
//                       <div 
//                         className="absolute pointer-events-none z-30"
//                         style={{ 
//                           left: clickAnimation.x - 15, 
//                           top: clickAnimation.y - 15 
//                         }}
//                       >
//                         {/* Primary pulse */}
//                         <div className="w-8 h-8 bg-blue-400 rounded-full animate-ping opacity-75"></div>
//                         {/* Secondary pulse */}
//                         <div className="absolute inset-0 w-8 h-8 bg-white rounded-full animate-pulse opacity-90"></div>
//                         {/* Core dot */}
//                         <div className="absolute inset-0 w-8 h-8 flex items-center justify-center">
//                           <div className="w-2 h-2 bg-blue-600 rounded-full"></div>
//                         </div>
//                         {/* Expanding ring */}
//                         <div className="absolute inset-0 w-8 h-8 border-2 border-blue-500 rounded-full animate-ping"></div>
//                       </div>
//                     )}
                    
//                     {/* Ripple effects */}
//                     {ripples.map((ripple) => (
//                       <div
//                         key={ripple.id}
//                         className="absolute pointer-events-none z-20"
//                         style={{
//                           left: ripple.x - 25,
//                           top: ripple.y - 25,
//                         }}
//                       >
//                         <div className="w-12 h-12 border border-blue-300 rounded-full animate-ping opacity-60"></div>
//                         <div className="absolute inset-2 w-8 h-8 border border-blue-400 rounded-full animate-ping opacity-80 animation-delay-150"></div>
//                         <div className="absolute inset-4 w-4 h-4 border border-blue-500 rounded-full animate-ping opacity-90 animation-delay-300"></div>
//                       </div>
//                     ))}
                    
//                     {/* Subtle click zones indicator on hover */}
//                     <div className="absolute inset-0 flex opacity-0 group-hover:opacity-10 transition-opacity duration-300 pointer-events-none">
//                       <div className="w-[30%] h-full bg-gray-200 flex items-center justify-center">
//                         <ChevronLeft className="text-gray-600 opacity-50" size={20} />
//                       </div>
//                       <div className="w-[40%] h-full bg-gray-100 flex items-center justify-center">
//                         <div className="text-gray-600 opacity-50 text-center">
//                           <ChevronRight size={20} />
//                         </div>
//                       </div>
//                       <div className="w-[30%] h-full bg-gray-200 flex items-center justify-center">
//                         <ChevronRight className="text-gray-600 opacity-50" size={20} />
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//                 {/* Home indicator */}
//                 <div className="w-24 h-1 bg-gray-500 rounded-full mx-auto mt-2"></div>
//               </div>
//             </div>
//           ) : (
//             <div className="relative max-w-xs mx-auto">
//               {/* Selection background for desktop */}
//               <div className="absolute -inset-3 border-2 border-dashed border-blue-400 bg-blue-50 bg-opacity-30 rounded-lg transition-all duration-300"></div>

//               {/* Desktop ad frame */}
//               <div className="bg-white rounded-lg shadow-2xl p-4">
//                 <div 
//                   className="w-[280px] h-[500px] bg-gray-100 rounded overflow-hidden relative group cursor-pointer"
//                   style={{ cursor: cursorStyle }}
//                   onClick={handleImageClick}
//                 >
//                   <div className={`transition-all duration-300 w-full h-full ${isAnimating ? 'opacity-0 scale-90 rotate-1' : 'opacity-100 scale-100 rotate-0'}`}>
//                     <div className="w-full h-full flex items-center justify-center text-white relative overflow-hidden group-hover:scale-[1.02] transition-transform duration-300">
//                       <img 
//                         src={images[currentImageIndex].src} 
//                         alt={images[currentImageIndex].alt} 
//                         className="w-full h-full object-contain absolute inset-0 transition-all duration-300"
//                         style={{ 
//                           objectFit: 'contain',
//                           filter: getCurrentFilter()
//                         }}
//                       />
//                         {/* Navigation indicator at bottom */}
//                         <div className="absolute bottom-4 left-1/2 transform -translate-x-1/2 z-10 pointer-events-none">
//                           <div className="bg-black bg-opacity-60 px-3 py-2 rounded-full backdrop-blur-sm flex items-center gap-2">
//                             <div className="text-lg opacity-80 animate-pulse">👆</div>
//                             <div className="text-xs text-gray-200">Click to navigate</div>
//                           </div>
//                         </div>
//                     </div>
//                   </div>
                  
//                   {/* Enhanced click animation */}
                  // {clickAnimation.show && (
                  //   <div 
                  //     className="absolute pointer-events-none z-30"
                  //     style={{ 
                  //       left: clickAnimation.x - 15, 
                  //       top: clickAnimation.y - 15 
                  //     }}
                  //   >
                  //     {/* Primary pulse */}
                  //     <div className="w-8 h-8 bg-blue-400 rounded-full animate-ping opacity-75"></div>
                  //     {/* Secondary pulse */}
                  //     <div className="absolute inset-0 w-8 h-8 bg-white rounded-full animate-pulse opacity-90"></div>
                  //     {/* Core dot */}
                  //     <div className="absolute inset-0 w-8 h-8 flex items-center justify-center">
                  //       <div className="w-2 h-2 bg-blue-600 rounded-full"></div>
                  //     </div>
                  //     {/* Expanding ring */}
                  //     <div className="absolute inset-0 w-8 h-8 border-2 border-blue-500 rounded-full animate-ping"></div>
                  //   </div>
                  // )}
                  
                  // {/* Ripple effects */}
                  // {ripples.map((ripple) => (
                  //   <div
                  //     key={ripple.id}
                  //     className="absolute pointer-events-none z-20"
                  //     style={{
                  //       left: ripple.x - 25,
                  //       top: ripple.y - 25,
                  //     }}
                  //   >
                  //     <div className="w-12 h-12 border border-blue-300 rounded-full animate-ping opacity-60"></div>
                  //     <div className="absolute inset-2 w-8 h-8 border border-blue-400 rounded-full animate-ping opacity-80 animation-delay-150"></div>
                  //     <div className="absolute inset-4 w-4 h-4 border border-blue-500 rounded-full animate-ping opacity-90 animation-delay-300"></div>
                  //   </div>
                  // ))}
                  
//                   {/* Image counter overlay */}
//                   <div className="absolute top-3 right-3 bg-black bg-opacity-60 text-white px-2 py-1 rounded-full text-xs backdrop-blur-sm">
//                     {currentImageIndex + 1}/{images.length}
//                   </div>
                  
//                   {/* Subtle click zones indicator on hover */}
//                   <div className="absolute inset-0 flex opacity-0 group-hover:opacity-10 transition-opacity duration-300 pointer-events-none">
//                     <div className="w-[30%] h-full bg-gray-200 flex items-center justify-center">
//                       <ChevronLeft className="text-gray-600 opacity-50" size={20} />
//                     </div>
//                     <div className="w-[40%] h-full bg-gray-100 flex items-center justify-center">
//                       <div className="text-gray-600 opacity-50 text-center">
//                         <ChevronRight size={20} />
//                       </div>
//                     </div>
//                     <div className="w-[30%] h-full bg-gray-200 flex items-center justify-center">
//                       <ChevronRight className="text-gray-600 opacity-50" size={20} />
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           )}
//         </div>
//       </div>

//       {/* Right Sidebar */}
//       <div className="w-full md:w-80 bg-white border-t md:border-t-0 md:border-l border-gray-200 p-4">
//         <h3 className="text-lg font-semibold text-gray-800 mb-6">Creative Details</h3>

//         <div className="space-y-6">
//           <div>
//             <h4 className="text-sm font-medium text-gray-600 mb-2">Current Image</h4>
//             <p className="text-gray-800">{images[currentImageIndex].alt}</p>
//           </div>

//           <div>
//             <h4 className="text-sm font-medium text-gray-600 mb-2">Active Filter</h4>
//             <div className="flex items-center gap-2">
//               <span className="text-2xl">{imageFilters.find(f => f.id === selectedFilter)?.preview}</span>
//               <div>
//                 <p className="text-gray-800 font-medium">{imageFilters.find(f => f.id === selectedFilter)?.name}</p>
//                 <p className="text-xs text-gray-500">{imageFilters.find(f => f.id === selectedFilter)?.description}</p>
//               </div>
//             </div>
//           </div>

//           <div>
//             <h4 className="text-sm font-medium text-gray-600 mb-1">Ad Dimension:</h4>
//             <p className="text-gray-800">300x600</p>
//           </div>

//           <div>
//             <h4 className="text-sm font-medium text-gray-600 mb-1">Ad Type:</h4>
//             <p className="text-gray-800">Banner - Javascript tag</p>
//           </div>

//           <div>
//             <h4 className="text-sm font-medium text-gray-600 mb-1">Creative ID:</h4>
//             <p className="text-gray-800">1526050</p>
//           </div>

//           <div className="flex gap-2">
//             <button className="text-blue-500 hover:text-blue-600 hover:underline text-sm flex items-center gap-1 transition-colors duration-200">
//               <Eye className="h-3 w-3" />
//               Full-Size View
//             </button>
//             <button className="text-blue-500 hover:text-blue-600 hover:underline text-sm flex items-center gap-1 transition-colors duration-200">
//               <ZoomIn className="h-3 w-3" />
//               Zoom
//             </button>
//           </div>

//           {/* Animation Controls */}
//           <div className="border-t pt-4">
//             <h4 className="text-sm font-medium text-gray-600 mb-2">Quick Actions</h4>
//             <div className="space-y-2">
//               <button 
//                 className="w-full text-left px-3 py-2 bg-gray-50 hover:bg-gray-100 rounded-lg text-sm transition-all duration-200 hover:scale-[1.02]"
//                 onClick={() => goToImage(0)}
//               >
//                 🏠 Go to First
//               </button>
//               <button 
//                 className="w-full text-left px-3 py-2 bg-gray-50 hover:bg-gray-100 rounded-lg text-sm transition-all duration-200 hover:scale-[1.02]"
//                 onClick={() => goToImage(images.length - 1)}
//               >
//                 🏁 Go to Last
//               </button>
//               <button 
//                 className="w-full text-left px-3 py-2 bg-gray-50 hover:bg-gray-100 rounded-lg text-sm transition-all duration-200 hover:scale-[1.02]"
//                 onClick={() => goToImage(Math.floor(Math.random() * images.length))}
//               >
//                 🎲 Random Image
//               </button>
//               <button 
//                 className="w-full text-left px-3 py-2 bg-gray-50 hover:bg-gray-100 rounded-lg text-sm transition-all duration-200 hover:scale-[1.02]"
//                 onClick={() => handleFilterClick('original')}
//               >
//                 🔄 Reset Filter
//               </button>
//             </div>
//           </div>

//           {/* QR Code */}
//           <div className="mt-8 flex justify-center">
//             <div className="w-32 h-32 bg-white border-2 border-gray-300 p-2 rounded-lg shadow-sm">
//               <div className="w-full h-full bg-black relative">
//                 {/* QR Code pattern */}
//                 <div className="absolute inset-1 bg-white"></div>
//                 <div className="absolute top-1 left-1 w-6 h-6 bg-black"></div>
//                 <div className="absolute top-1 right-1 w-6 h-6 bg-black"></div>
//                 <div className="absolute bottom-1 left-1 w-6 h-6 bg-black"></div>
//                 <div className="absolute top-2 left-2 w-4 h-4 bg-white"></div>
//                 <div className="absolute top-2 right-2 w-4 h-4 bg-white"></div>
//                 <div className="absolute bottom-2 left-2 w-4 h-4 bg-white"></div>
//                 <div className="absolute top-3 left-3 w-2 h-2 bg-black"></div>
//                 <div className="absolute top-3 right-3 w-2 h-2 bg-black"></div>
//                 <div className="absolute bottom-3 left-3 w-2 h-2 bg-black"></div>
//                 <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-8 h-8 bg-black"></div>
//                 <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-6 h-6 bg-white"></div>
//                 <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-4 h-4 bg-black"></div>
//                 {/* Random dots */}
//                 <div className="absolute top-8 left-4 w-1 h-1 bg-black"></div>
//                 <div className="absolute top-10 left-6 w-1 h-1 bg-black"></div>
//                 <div className="absolute top-12 left-8 w-1 h-1 bg-black"></div>
//                 <div className="absolute top-14 left-10 w-1 h-1 bg-black"></div>
//                 <div className="absolute top-16 left-4 w-1 h-1 bg-black"></div>
//                 <div className="absolute top-18 left-8 w-1 h-1 bg-black"></div>
//                 <div className="absolute top-20 left-6 w-1 h-1 bg-black"></div>
//                 <div className="absolute top-22 left-10 w-1 h-1 bg-black"></div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }
import React, { useState, useEffect } from 'react';
import { ArrowLeft, Eye, ArrowRight, Plane, Heart, MapPin, Calendar, Camera, Star, Globe, ChevronLeft, ChevronRight } from 'lucide-react';
import { Link } from 'react-router-dom';

const ImageAdContent = ({ isInPreview = false, isExpanded = false, onExpand, onClose }) => {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  
    const images = [
      { 
        src: '/assets/1.png', 
        alt: 'Filter Classic Ad',
      },
      { 
        src: '/assets/2.png',       
        alt: 'Filter Zero Ad',
      },
      { 
        src: '/assets/3.png',       
        alt: 'Filter Life Ad',
      },
      { 
        src: '/assets/4.png',       
        alt: 'Filter Orange Ad',
      }
    ];

  const nextImage = (e) => {
    if (e) {
      e.stopPropagation();
    }
    setCurrentImageIndex((prev) => (prev + 1) % images.length);
  };

  const prevImage = (e) => {
    if (e) {
      e.stopPropagation();
    }
    setCurrentImageIndex((prev) => (prev - 1 + images.length) % images.length);
  };

  const handleExpand = (e) => {
    if (e) {
      e.stopPropagation();
    }
    if (onExpand && !isInPreview) {
      onExpand();
    }
  };

  const handleImageClick = (e) => {
    if (e) {
      e.stopPropagation();
    }
    
    if (!isExpanded && !isInPreview) {
      handleExpand(e);
    } else {
      nextImage(e);
    }
  };

  return (
    <div className={`w-full h-full relative overflow-hidden ${isExpanded ? 'fixed inset-0 z-50 bg-black' : ''}`}>
      {!isExpanded ? (
        <div className="relative h-full">
          {/* Compact Image Ad */}
          <div 
            className={`relative cursor-pointer transform transition-all duration-300 ${
              !isInPreview ? 'hover:scale-105' : ''
            } w-full h-full`}
            onClick={handleImageClick}
          >
            {/* Image Container */}
            <div className="relative w-full h-full overflow-hidden">
              <img
                src={images[currentImageIndex].src}
                alt={images[currentImageIndex].alt}
                className="w-full h-full object-cover transition-opacity duration-300"
              />

              {/* Ad Label */}
              <div className="absolute top-2 left-2 bg-black bg-opacity-60 text-white px-2 py-1 rounded text-xs font-medium">
                AD
              </div>

              {/* Navigation arrows for preview mode */}
              {/* {isInPreview && (
                <>
                  <button
                    onClick={prevImage}
                    className="absolute left-2 top-1/2 transform -translate-y-1/2 w-8 h-8 bg-black bg-opacity-60 hover:bg-opacity-80 rounded-full flex items-center justify-center text-white transition-all duration-200 hover:scale-110"
                  >
                    <ChevronLeft className="w-4 h-4" />
                  </button>
                  <button
                    onClick={nextImage}
                    className="absolute right-2 top-1/2 transform -translate-y-1/2 w-8 h-8 bg-black bg-opacity-60 hover:bg-opacity-80 rounded-full flex items-center justify-center text-white transition-all duration-200 hover:scale-110"
                  >
                    <ChevronRight className="w-4 h-4" />
                  </button>
                </>
              )} */}

              {/* Click indicator */}
              {/* <div className="absolute bottom-2 right-2 bg-black bg-opacity-60 text-white px-2 py-1 rounded text-xs font-medium opacity-70">
                {isInPreview ? 'Use arrows or click' : 'Click to expand'}
              </div> */}

              {/* Image dots indicator */}
              {/* <div className="absolute bottom-2 left-2 flex space-x-1">
                {images.map((_, index) => (
                  <div
                    key={index}
                    className={`w-2 h-2 rounded-full transition-all duration-200 ${
                      index === currentImageIndex ? 'bg-white' : 'bg-white/50'
                    }`}
                  />
                ))}
              </div> */}
            </div>
          </div>
        </div>
      ) : (
        /* Expanded Image Experience - Full Screen */
        <div className="w-full h-full flex items-center justify-center relative">
          <button
            onClick={(e) => {
              e.stopPropagation();
              onClose();
            }}
            className="absolute top-4 right-4 w-10 h-10 bg-white/20 hover:bg-white/30 rounded-full flex items-center justify-center text-white text-xl font-bold transition-all duration-300 hover:scale-110 z-10"
          >
            ×
          </button>
          
          {/* Navigation arrows for expanded view */}
          <button
            onClick={prevImage}
            className="absolute left-4 top-1/2 transform -translate-y-1/2 w-12 h-12 bg-white/20 hover:bg-white/30 rounded-full flex items-center justify-center text-white transition-all duration-300 hover:scale-110 z-10"
          >
            <ChevronLeft className="w-6 h-6" />
          </button>
          
          <button
            onClick={nextImage}
            className="absolute right-4 top-1/2 transform -translate-y-1/2 w-12 h-12 bg-white/20 hover:bg-white/30 rounded-full flex items-center justify-center text-white transition-all duration-300 hover:scale-110 z-10"
          >
            <ChevronRight className="w-6 h-6" />
          </button>
          
          <div className="relative w-full h-full max-w-4xl flex items-center justify-center">
            <img
              src={images[currentImageIndex].src}
              alt={images[currentImageIndex].alt}
              className="max-w-full max-h-full object-contain cursor-pointer"
              onClick={nextImage}
            />

            {/* Image counter */}
            <div className="absolute top-4 left-4 bg-black/60 backdrop-blur-sm rounded-lg px-3 py-2 text-white text-sm">
              {currentImageIndex + 1} / {images.length}
            </div>

            {/* Click indicator for expanded view */}
            <div className="absolute bottom-4 right-4 bg-black/60 backdrop-blur-sm rounded-lg px-3 py-2 text-white text-sm opacity-70">
              Click image or arrows to change
            </div>

            {/* Image dots indicator */}
            <div className="absolute bottom-4 left-1/2 transform -translate-x-1/2 flex space-x-2">
              {images.map((_, index) => (
                <button
                  key={index}
                  onClick={(e) => {
                    e.stopPropagation();
                    setCurrentImageIndex(index);
                  }}
                  className={`w-3 h-3 rounded-full transition-all duration-200 ${
                    index === currentImageIndex ? 'bg-white' : 'bg-white/50 hover:bg-white/70'
                  }`}
                />
              ))}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

function App() {
  const [isMobile, setIsMobile] = useState(true);
  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <>
    <div className="min-h-screen bg-gray-50 mt-10">
      <div className="container mx-auto px-4 py-8 lg:py-12">
        <div className="flex flex-col lg:flex-row lg:items-start lg:space-x-12">
          {/* Left column - Content */}
          <div className="flex-1 lg:max-w-lg">
            {/* Header */}
            <header className="animate-slide-up">
              {/* Title and tag */}
              <div className="mb-4 lg:mt-16 md:mt-10 sm:mt-0">
                <div className="flex flex-wrap items-center gap-3 mb-3">
                  <h1 className="text-3xl lg:text-4xl font-bold text-gray-900 leading-tight">
                  Click the Filter. See the Magic.
                  </h1>
                  <span className="bg-blue-500 text-white px-3 py-1 rounded-full text-sm font-medium">
                  Gamification
                  </span>
                </div>
              </div>
            </header>

            {/* Content Section */}
            <div className="animate-slide-up" style={{ animationDelay: '0.2s' }}>
              {/* Make it yours section */}
              <div className="mb-8">
                <h2 className="text-lg font-bold text-blue-600 mb-4 tracking-wide">
                SHOWCASE YOUR FEATURES LIVE
                </h2>
                <p className="text-gray-700 leading-relaxed mb-6 max-w-md">
                This interactive image carousel lets users tap through filters to see real-time changes inside the phone frame, perfect for highlighting camera capabilities. Each click swaps the visual, showing off how your tech transforms every shot. Samsung launch a hands-on demo that feels like using the device itself.
                </p>
                
                {/* CTA Button */}
                <button className="group bg-white border-2 border-blue-500 text-blue-500 px-6 py-3 rounded-full font-medium hover:bg-blue-500 hover:text-white transition-all duration-300 flex items-center space-x-2 shadow-sm hover:shadow-md transform hover:-translate-y-0.5">
                  <span>Start with this Template</span>
                  <ArrowRight className="w-4 h-4 transform group-hover:translate-x-1 transition-transform duration-200" />
                </button>
              </div>
            </div>
          </div>

          {/* Right column - Template Preview */}
          <div className="flex-1 lg:max-w-2xl mt-8 lg:mt-0">
            {/* Preview toggle */}
            <div className="hidden lg:flex justify-center mt-2 animate-fade-in mb-4" style={{ animationDelay: '0.3s' }}>
              <div className="bg-white rounded-full px-6 py-3 shadow-lg border border-gray-200">
                <div className="flex items-center space-x-4">
                  <div className="flex items-center space-x-3">
                    <span className={`text-sm font-medium transition-colors ${isMobile ? 'text-blue-600' : 'text-gray-600'}`}>
                      Mobile
                    </span>
                    <button
                      onClick={() => setIsMobile(!isMobile)}
                      className="relative w-12 h-6 bg-blue-500 rounded-full transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
                    >
                      <div className={`absolute top-1 w-4 h-4 bg-white rounded-full transition-transform duration-200 ${isMobile ? 'left-1' : 'left-7'}`}></div>
                    </button>
                    <span className={`text-sm font-medium transition-colors ${!isMobile ? 'text-blue-600' : 'text-gray-600'}`}>
                      Desktop
                    </span>
                  </div>
                </div>
              </div>
            </div>

            <div className="relative animate-fade-in" style={{ animationDelay: '0.4s' }}>
              {/* Mobile Mockup */}
              {isMobile && (
                <div className="mx-auto max-w-xs">
                  {/* iPhone mockup */}
                  <div className="relative rounded-[2.5rem] p-2 shadow-2xl">
                    {/* Status bar area */}
                    <div className="bg-white rounded-[2rem] overflow-hidden">
                      {/* Status bar */}
                      <div className="bg-white px-6 py-2 flex justify-between items-center text-black text-sm font-medium">
                        <span>9:41</span>
                        <div className="flex items-center space-x-1">
                          <div className="flex space-x-1">
                            <div className="w-1 h-1 bg-black rounded-full"></div>
                            <div className="w-1 h-1 bg-black rounded-full"></div>
                            <div className="w-1 h-1 bg-black rounded-full"></div>
                            <div className="w-1 h-1 bg-black rounded-full"></div>
                          </div>
                          <div className="w-6 h-3 border border-black rounded-sm relative">
                            <div className="w-4/5 h-full bg-green-500 rounded-sm"></div>
                          </div>
                        </div>
                      </div>

                      {/* Browser bar */}
                      <div className="bg-gray-100 px-4 py-3 flex items-center space-x-3">
                        <div className="flex-1 bg-white rounded-lg px-3 py-2 text-sm text-gray-600 flex items-center justify-center">
                          publisher.com
                        </div>
                      </div>

                      {/* Content area */}
                      <div className="p-4 bg-gray-50  h-[400px] overflow-y-auto hide-scrollbar">
                        <div className="space-y-3">
                          <div className="h-3 bg-gray-200 rounded w-full"></div>
                          <div className="h-3 bg-gray-200 rounded w-full"></div>
                          <div className="h-3 bg-gray-200 rounded w-full"></div>
                        </div>
                        
                        {/* Image Ad - Full width on mobile with same gap from top */}
                        <div className="mb-6">
                          <div className="h-64 rounded-lg overflow-hidden">
                            <ImageAdContent 
                              isInPreview={true}
                              isExpanded={isExpanded}
                              onExpand={() => setIsExpanded(true)}
                              onClose={() => setIsExpanded(false)}
                            />
                          </div>
                        </div>
                        <div className="space-y-3">
                          <div className="h-3 bg-gray-200 rounded w-full"></div>
                          <div className="h-3 bg-gray-200 rounded w-5/6"></div>
                          <div className="h-3 bg-gray-200 rounded w-4/6"></div>
                        </div>
                        <div className="space-y-3 mt-2">
                          <div className="h-3 bg-gray-200 rounded w-full"></div>
                          <div className="h-3 bg-gray-200 rounded w-5/6"></div>
                          <div className="h-3 bg-gray-200 rounded w-4/6"></div>
                        </div>
                        <div className="space-y-3 mt-2">
                          <div className="h-3 bg-gray-200 rounded w-full"></div>
                          <div className="h-3 bg-gray-200 rounded w-5/6"></div>
                          <div className="h-3 bg-gray-200 rounded w-4/6"></div>
                        </div>
                        <div className="space-y-3 mt-2">
                          <div className="h-3 bg-gray-200 rounded w-full"></div>
                          <div className="h-3 bg-gray-200 rounded w-5/6"></div>
                          <div className="h-3 bg-gray-200 rounded w-4/6"></div>
                        </div>
                        {/* Additional content placeholders */}
                        <div className="space-y-3">
                          <div className="h-3 bg-gray-200 rounded w-full"></div>
                          <div className="h-3 bg-gray-200 rounded w-full"></div>
                          <div className="h-3 bg-gray-200 rounded w-full"></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}

              {/* Desktop Mockup */}
              {!isMobile && (
                <div className="w-full max-w-2xl mx-auto">
                  {/* Desktop Screen Frame */}
                  <div className="bg-gray-200 rounded-xl p-3 shadow-2xl">
                    {/* Screen */}
                    <div className="bg-white rounded-lg overflow-hidden shadow-inner" style={{ aspectRatio: '16/10' }}>
                      {/* macOS-style window header */}
                      <div className="bg-gray-100 px-1 py-1 flex items-center border-b border-gray-200">
                        <div className="flex space-x-2">
                          <div className="w-3 h-3 bg-red-400 rounded-full"></div>
                          <div className="w-3 h-3 bg-yellow-400 rounded-full"></div>
                          <div className="w-3 h-3 bg-green-400 rounded-full"></div>
                        </div>
                        <div className="flex-1 mx-6">
                          <div className="bg-white rounded-md px-1 py-1 text-sm text-gray-600 border shadow-sm max-w-md">
                            🔒 publisher.com
                          </div>
                        </div>
                        <div className="flex space-x-1">
                          <div className="w-4 h-4 bg-gray-300 rounded"></div>
                          <div className="w-4 h-4 bg-gray-300 rounded"></div>
                        </div>
                      </div>

                      {/* Browser content area */}
                      <div className="p-1 bg-gray-50 h-[500px] overflow-y-auto hide-scrollbar">
                        {/* Page header */}
                        <div className="mb-2">
                          <div className="h-4 bg-gray-200 rounded w-1/3 mb-2"></div>
                          <div className="h-3 bg-gray-200 rounded w-1/2"></div>
                        </div>

                        {/* Image Ad positioned in content with same gap from top */}
                        <div className="flex justify-center mb-2">
                          <div className="w-80 h-80 overflow-hidden">
                            <ImageAdContent 
                              isInPreview={true}
                              isExpanded={isExpanded}
                              onExpand={() => setIsExpanded(true)}
                              onClose={() => setIsExpanded(false)}
                            />
                          </div>
                        </div>

                        {/* Additional content placeholders */}
                        <div className="grid grid-cols-2 gap-6 mb-6">
                          <div className="space-y-3">
                            <div className="h-4 bg-gray-200 rounded w-full"></div>
                            <div className="h-3 bg-gray-200 rounded w-5/6"></div>
                            <div className="h-3 bg-gray-200 rounded w-4/6"></div>
                          </div>
                          <div className="space-y-3">
                            <div className="h-4 bg-gray-200 rounded w-full"></div>
                            <div className="h-3 bg-gray-200 rounded w-5/6"></div>
                            <div className="h-3 bg-gray-200 rounded w-4/6"></div>
                          </div>
                        </div>
                        <div className="grid grid-cols-3 gap-4">
                            <div className="h-24 bg-gray-200 rounded"></div>
                            <div className="h-24 bg-gray-200 rounded"></div>
                            <div className="h-24 bg-gray-200 rounded"></div>
                          </div>
                          <div className="grid grid-cols-2 gap-6 mb-6">
                          <div className="space-y-3">
                            <div className="h-4 bg-gray-200 rounded w-full"></div>
                            <div className="h-3 bg-gray-200 rounded w-5/6"></div>
                            <div className="h-3 bg-gray-200 rounded w-4/6"></div>
                          </div>
                          <div className="space-y-3">
                            <div className="h-4 bg-gray-200 rounded w-full"></div>
                            <div className="h-3 bg-gray-200 rounded w-5/6"></div>
                            <div className="h-3 bg-gray-200 rounded w-4/6"></div>
                          </div>
                        </div>
                        {/* Sidebar placeholders */}
                        <div className="grid grid-cols-3 gap-4">
                          <div className="h-24 bg-gray-200 rounded"></div>
                          <div className="h-24 bg-gray-200 rounded"></div>
                          <div className="h-24 bg-gray-200 rounded"></div>
                        </div>
                      </div>
                    </div>
                  </div>
                  
                  {/* Monitor stand */}
                  <div className="flex justify-center">
                    <div className="w-20 h-4 bg-gray-200 rounded-b-lg"></div>
                  </div>
                  <div className="flex justify-center">
                    <div className="w-32 h-2 bg-gray-300 rounded-full"></div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* Expanded Image Overlay */}
      {isExpanded && (
        <div className="fixed inset-0 z-50">
          <ImageAdContent 
            isExpanded={true}
            onClose={() => setIsExpanded(false)}
          />
        </div>
      )}

      <style jsx>{`
        @keyframes slide-up {
          from {
            opacity: 0;
            transform: translateY(20px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
        
        @keyframes fade-in {
          from { opacity: 0; }
          to { opacity: 1; }
        }
        
        .animate-slide-up {
          animation: slide-up 0.6s ease-out forwards;
        }
        
        .animate-fade-in {
          animation: fade-in 0.6s ease-out forwards;
        }
        
        .hide-scrollbar {
          -ms-overflow-style: none;
          scrollbar-width: none;
        }
        
        .hide-scrollbar::-webkit-scrollbar {
          display: none;
        }
      `}</style>
    </div>
    <div className="max-w-7xl mx-auto px-4 py-10">
                            <h1 className="text-3xl font-bold text-center text-gray-800 mb-10">Discover More Ads</h1>
                      
                            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
                              {/* Card 1 */}
                              <Link to="/tap-to-reveal/ps" className="block group rounded-xl overflow-hidden shadow-lg transition-transform duration-300 transform hover:scale-105 hover:shadow-2xl">
                                <img
                                  src="/assets/ps.avif"
                                  alt="Card 1"
                                  className="w-full h-60 object-cover transition-opacity duration-300 group-hover:opacity-80"
                                />
                                <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent text-white p-4 opacity-0 group-hover:opacity-100 transition-all duration-300">
                                  <h2 className="text-lg font-semibold">PS5</h2>
                                </div>
                              </Link>
                      
                              {/* Card 2 */}
                              <Link to="/video/mollers" className="block group rounded-xl overflow-hidden shadow-lg transition-transform duration-300 transform hover:scale-105 hover:shadow-2xl">
                                <img
                                  src="/assets/moll.avif"
                                  alt="Card 2"
                                  className="w-full h-60 object-cover transition-opacity duration-300 group-hover:opacity-80"
                                />
                                <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent text-white p-4 opacity-0 group-hover:opacity-100 transition-all duration-300">
                                  <h2 className="text-lg font-semibold">Mollers</h2>
                                </div>
                              </Link>
                      
                              {/* Card 3 */}
                              <Link to="/video/tiger" className="block group rounded-xl overflow-hidden shadow-lg transition-transform duration-300 transform hover:scale-105 hover:shadow-2xl">
                                <img
                                  src="/assets/tiger.avif"
                                  alt="Card 3"
                                  className="w-full h-60 object-cover transition-opacity duration-300 group-hover:opacity-80"
                                />
                                <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent text-white p-4 opacity-0 group-hover:opacity-100 transition-all duration-300">
                                  <h2 className="text-lg font-semibold">Tiger</h2>
                                </div>
                              </Link>
                      
                              {/* Card 4 */}
                              <Link to="/drag-to-reveal/abcbeer" className="block group rounded-xl overflow-hidden shadow-lg transition-transform duration-300 transform hover:scale-105 hover:shadow-2xl">
                                <img
                                  src="/assets/ab.avif"
                                  alt="Card 4"
                                  className="w-full h-60 object-cover transition-opacity duration-300 group-hover:opacity-80"
                                />
                                <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent text-white p-4 opacity-0 group-hover:opacity-100 transition-all duration-300">
                                  <h2 className="text-lg font-semibold">ABC Beer</h2>
                                </div>
                              </Link>
                      
                             
                            </div>
                          </div>
 
    </>
  );
}

export default App;

